import { render } from "./StagePositionDeviceIdentity.vue?vue&type=template&id=43fbdb8c&scoped=true"
import script from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"
export * from "./StagePositionDeviceIdentity.vue?vue&type=script&lang=js"

import "./StagePositionDeviceIdentity.vue?vue&type=style&index=0&id=43fbdb8c&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fbdb8c"]])

export default __exports__